module.exports = __webpack_public_path__ + "img/INVENTO.674f5542.png";